module.exports = __webpack_public_path__ + "img/PXL_20230524_183138731.61bf3ed4.jpg";